var PrismTheme = {
  plain: {
    backgroundColor: '#2a2734',
    color: '#fff'
  },
  styles: [{
    types: ['comment', 'prolog', 'doctype', 'cdata'],
    style: {
      color: '#7c7c7c'
    }
  }, {
    types: ['punctuation'],
    style: {
      color: '#c5c8c6'
    }
  }, {
    types: ['namespace'],
    style: {
      opacity: 0.7
    }
  }, {
    types: ['class-name', 'entity'],
    style: {
      color: '#ffffb6'
    }
  }, {
    types: ['class-name'],
    style: {
      textDecoration: 'underline'
    }
  }, {
    types: ['entity'],
    style: {
      cursor: 'help'
    }
  }, {
    types: ['keyword', 'property', 'tag', 'url'],
    style: {
      color: '#96cbfe'
    }
  }, {
    types: ['boolean', 'constant'],
    style: {
      color: '#9c9'
    }
  }, {
    types: ['deleted', 'symbol'],
    style: {
      color: '#f92672'
    }
  }, {
    types: ['number'],
    style: {
      color: '#ff73fd'
    }
  }, {
    types: ['operator'],
    style: {
      color: '#ededed'
    }
  }, {
    types: ['attr-name', 'builtin', 'char', 'inserted', 'selector', 'string'],
    style: {
      color: '#a8ff60'
    }
  }, {
    types: ['variable'],
    style: {
      color: '#c6c5fe'
    }
  }, {
    types: ['attr-value', 'at-rule'],
    style: {
      color: '#f9ee98'
    }
  }, {
    types: ['function'],
    style: {
      color: '#dad085'
    }
  }, {
    types: ['regex'],
    style: {
      color: '#e9c062'
    }
  }, {
    types: ['important'],
    style: {
      color: '#fd971f'
    }
  }, {
    types: ['bold', 'important'],
    style: {
      fontWeight: 700
    }
  }, {
    types: ['italic'],
    style: {
      fontStyle: 'italic'
    }
  }]
};
export default PrismTheme;
//# sourceMappingURL=LiveDemoTheme.js.map